import React, { useState, useEffect } from "react";
import "./style.css";
import API from "../../utils/API";
import cogoToast from "@successtar/cogo-toast";
import AIForm from "../../components/AIForm";

function CreateClient() {
  const [formData, setFormData] = useState({
    clientFirstName: "",
    clientLastName: "",
    clientEmail: "",
    clientTelephone: "",
    clientServicer: "",
    agent1: "",
    agent2: "",
    agent3: "",
    agent4: ""
  });

  const [agents, setAgents] = useState(null);

  useEffect(() => {
    API.getAgents()
      .then((res) => setAgents(res.data))
      .catch((_err) => console.log(_err));
  }, []);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const readFormData = (e, aiFormData) => {
    e.preventDefault();

    // Clients do NOT get Firebase accounts — there are no client logins. The old
    // browser-side createUserWithEmailAndPassword call 400s now that public signup
    // is disabled (so the save below never ran), and on success it silently
    // re-authenticated this browser AS the newly created client. POST straight to
    // the backend instead; the Client schema defaults `uid` server-side, so we
    // must not send one.
    if (!aiFormData.firstName || !aiFormData.lastName || !aiFormData.email) {
      cogoToast.error("First name, last name and email are required.");
      return;
    }

    API.saveClient({
      firstName: aiFormData.firstName,
      lastName: aiFormData.lastName,
      email: aiFormData.email,
      telephone: aiFormData.telephone,
      servicer: "Fawn Circle",
      agent1: formData.agent1,
      agent2: formData.agent2,
      agent3: formData.agent3,
      agent4: formData.agent4
    })
      .then(() => {
        cogoToast.success(
          "Created client " + aiFormData.firstName + " " + aiFormData.lastName + "."
        );
      })
      .catch((err) => {
        console.log(err);
        cogoToast.error("Couldn't create the client. Please try again.");
      });
  };

  return (
    <div>
      <h2>Tag Agents to be associated with this client</h2>
      <div className="row">
        <div className="col-lg-4 offset-lg-1 col-12">
          <label>Choose Agent 1</label>
          <input list="agents" value={formData.agent1} name="agent1" onChange={handleInputChange} />
          {agents ? (
            <datalist id="agents">
              {agents.map((agent) => (
                <option key={agent._id} value={agent._id}>
                  {agent.firstName} {agent.lastName}
                </option>
              ))}
            </datalist>
          ) : null}
        </div>
        <div className="col-lg-4 offset-lg-1 col-12">
          <label>Choose Agent 2</label>
          <input list="agents" value={formData.agent2} name="agent2" onChange={handleInputChange} />
          {agents ? (
            <datalist id="agents">
              {agents.map((agent) => (
                <option key={agent._id} value={agent._id}>
                  {agent.firstName} {agent.lastName}
                </option>
              ))}
            </datalist>
          ) : null}
        </div>
        <div className="col-lg-4 offset-lg-1 col-12">
          <label>Choose Agent 3</label>
          <input list="agents" value={formData.agent3} name="agent3" onChange={handleInputChange} />
          {agents ? (
            <datalist id="agents">
              {agents.map((agent) => (
                <option key={agent._id} value={agent._id}>
                  {agent.firstName} {agent.lastName}
                </option>
              ))}
            </datalist>
          ) : null}
        </div>
        <div className="col-lg-4 offset-lg-1 col-12">
          <label>Choose Agent 4</label>
          <input list="agents" value={formData.agent4} name="agent4" onChange={handleInputChange} />
          {agents ? (
            <datalist id="agents">
              {agents.map((agent) => (
                <option key={agent._id} value={agent._id}>
                  {agent.firstName} {agent.lastName}
                </option>
              ))}
            </datalist>
          ) : null}
        </div>
      </div>
      <AIForm
        formTitle="Create Client"
        formData={[
          {
            id: "1",
            inputName: "firstName",
            inputLabel: "First Name",
            inputType: "text",
            inputValue: ""
          },
          {
            id: "2",
            inputName: "lastName",
            inputLabel: "Last Name",
            inputType: "text",
            inputValue: ""
          },
          {
            id: "3",
            inputName: "telephone",
            inputLabel: "Phone Number",
            inputType: "text",
            inputValue: ""
          },
          {
            id: "9",
            inputName: "email",
            inputLabel: "Client Email",
            inputType: "text",
            inputValue: ""
          },
          {
            id: "10",
            inputName: "clientDOB",
            inputLabel: "Date of Birth",
            inputType: "date",
            inputValue: ""
          }
        ]}
        returnFormData={readFormData}
      />
    </div>
  );
}

export default CreateClient;
